export default __webpack_public_path__ + "static/media/017-no overtaking.e093fefa.png";